import React from "react";

const DatepickerInput = ({ ...props }) => {
  return <input type="text" {...props} readOnly={!props.enableTyping} />
};

export default DatepickerInput;
